import { render, staticRenderFns } from "./FormSelectbox.vue?vue&type=template&id=563af901"
import script from "./FormSelectbox.vue?vue&type=script&lang=js"
export * from "./FormSelectbox.vue?vue&type=script&lang=js"
import style0 from "./FormSelectbox.vue?vue&type=style&index=0&id=563af901&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports